import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  return (
    <div className="min-h-screen bg-slate-50 pt-24 pb-12 px-6">
      <div className="max-w-5xl mx-auto">

        {/* --- HERO SECTION (Jo aapka pehle tha) --- */}
        <div className="bg-white rounded-3xl p-10 shadow-xl text-center mb-12 border border-slate-100">
          <h1 className="text-4xl md:text-5xl font-extrabold text-slate-800 mb-4">
            Connecting India's <span className="text-blue-600">Hardworking Hands</span>
          </h1>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto mb-6">
            KaamSetu is a free platform dedicated to helping daily wage workers find employment and helping homeowners find verified workers instantly.
          </p>
          <div className="flex justify-center gap-4">
            <Link to="/find-workers" className="bg-blue-600 text-white px-6 py-3 rounded-full font-bold hover:bg-blue-700 transition">
              Find Workers 🔍
            </Link>
            <Link to="/add-worker" className="bg-slate-200 text-slate-800 px-6 py-3 rounded-full font-bold hover:bg-slate-300 transition">
              Join as Worker 👷
            </Link>
          </div>
        </div>

        {/* --- ADSENSE CONTENT SECTION START --- */}
        
        {/* 1. Services Section */}
        <div className="mb-16">
          <h2 className="text-3xl font-bold text-slate-800 mb-8 text-center">Services You Can Find 🛠️</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200">
              <h3 className="text-xl font-bold mb-2 text-blue-700">Skilled Masons (Rajmistri)</h3>
              <p className="text-slate-600">Find experienced Rajmistri for brickwork, plastering, and foundation laying. Best for residential and commercial construction.</p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200">
              <h3 className="text-xl font-bold mb-2 text-blue-700">Tiles & Marble Mistri</h3>
              <p className="text-slate-600">Connect with top-rated flooring experts who specialize in floor fitting, wall tiling, and granite work for modern homes.</p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200">
              <h3 className="text-xl font-bold mb-2 text-blue-700">Painters & POP</h3>
              <p className="text-slate-600">Give your home a new look with verified painters. Exterior weather-proof painting, interior POP designs, and false ceilings.</p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200">
              <h3 className="text-xl font-bold mb-2 text-blue-700">Electricians & Plumbers</h3>
              <p className="text-slate-600">Get licensed electricians for wiring and fitting, and experienced plumbers for piping and sanitary work immediately.</p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200">
              <h3 className="text-xl font-bold mb-2 text-blue-700">Labour & Helpers</h3>
              <p className="text-slate-600">Find hardworking helpers for shifting, mixing cement, and general site assistance. Available on daily wages.</p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200">
              <h3 className="text-xl font-bold mb-2 text-blue-700">Welder & Fabricator</h3>
              <p className="text-slate-600">Expert welders for gate making, window grills, and steel structures. Strong and durable work guaranteed.</p>
            </div>

          </div>
        </div>

        {/* 2. Educational / Blog Content (Google Isko Pasand Karta Hai) */}
        <div className="bg-white p-8 rounded-3xl shadow-lg border border-slate-100 mb-12">
          <h2 className="text-3xl font-bold mb-6 text-slate-900">Why Hiring Verified Labour is Important? ✅</h2>
          <div className="space-y-6 text-lg text-slate-600">
            <p>
              Building a home is one of the biggest investments in a person's life. However, the quality of construction depends entirely on the skills of the workers you hire. Using a platform like KaamSetu ensures safety and quality.
            </p>
            
            <div>
              <h3 className="font-bold text-slate-800 text-xl mb-2">🛡️ Safety and Security</h3>
              <p>Hiring unknown workers from a random chowk can be risky. KaamSetu encourages identity verification, ensuring that you know exactly who is working at your site.</p>
            </div>

            <div>
              <h3 className="font-bold text-slate-800 text-xl mb-2">💰 Cost Effectiveness</h3>
              <p>When you hire through middlemen, you often pay a heavy commission. KaamSetu removes the middleman, allowing you to negotiate rates directly with the workers.</p>
            </div>

            <div>
              <h3 className="font-bold text-slate-800 text-xl mb-2">📍 Local Availability</h3>
              <p>Construction work is time-sensitive. Our location-based search allows you to find workers within your specific Tehsil or District, reducing travel time.</p>
            </div>
          </div>
        </div>

        {/* 3. Mission Section (Aapka purana wala) */}
        <div className="bg-blue-600 text-white p-8 rounded-3xl shadow-lg text-center">
          <h2 className="text-2xl font-bold mb-4">🚀 Our Mission</h2>
          <p className="text-lg opacity-90">
            To organize the unorganized construction sector of India and provide a digital identity to every Shramik.
          </p>
        </div>

      </div>
    </div>
  );
};

export default About;